import React from "react";
import moment from "moment";
import "moment/locale/de";
import "moment/locale/fr";
import "moment/locale/it";

export default function ViewDateCellRenderer({ value }) {
  const dateFormatted = value => {
    const locale = window.navigator.userLanguage || window.navigator.language;
    moment.locale(locale);
    return moment(value).format("L");
  };

  const datevalue = value ? <span>{dateFormatted(value)}</span> : <span></span>;

  return datevalue;
}
